import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IDocumentRequest, DocumentRequest } from "@/models/document-request.entity";
import documentRequestService from "@/services/mrfiktiv/services/document-request.service";
import { MrfiktivDocumentRequestControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const DocumentRequestPageDataProvider = new (class extends AbstractPageDataProvider<
  IDocumentRequest,
  MrfiktivDocumentRequestControllerFindAllParamsGen
> {
  itemsPerPage = 100;

  async getPage(query: MrfiktivDocumentRequestControllerFindAllParamsGen): Promise<IPageViewModel<IDocumentRequest>> {
    const res = await documentRequestService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []).map((d) => new DocumentRequest(d));

    return { meta, data };
  }
})();
